import { gql } from '@apollo/client';

export const deleteListsAndFoldersMutation = gql`
  mutation DeleteListsAndFolders($contentIds: [Long!]!, $folderIds: [Long!]!) {
    deleteListContentsAndFolders(contentIds: $contentIds, folderIds: $folderIds) {
      deletedContent {
        id
        name
      }
      folderFailures {
        ... on ContentsAndFoldersFailure {
          __typename
        }
      }
    }
  }
`;

export const createListFolderMutation = gql`
  mutation CreateListFolder($name: String!, $locationId: Long) {
    createListFolder(name: $name, locationId: $locationId)
  }
`;

export const moveListsAndFoldersMutation = gql`
  mutation MoveListsAndFolders(
    $contentIds: [Long!]!
    $destinationId: Long!
    $folderIds: [Long!]!
  ) {
    moveListContentsAndFolders(
      destinationId: $destinationId
      folderIds: $folderIds
      contentIds: $contentIds
    ) {
      errors {
        ... on ContentsAndFoldersFailure {
          __typename
        }
      }
      movedContent {
        id
        name
      }
    }
  }
`;

export const renameListFolderMutation = gql`
 mutation RenameListFolder($folderId: Long!, $newName: String!) {
    renameListFolder(folderId: $folderId, newName: $newName) {
      ... on FolderRenamed {
        success {
          folderId
          folderName
        }
      }
      ... on RenameFailure {
        failure {
          ... on CannotRenameRootFolderFailure {
            id
          }
          ... on FolderNameConflictFailure {
            id
            name
          }
          ... on InvalidFolderNameFailure {
            id
            name
          }
        }
      }
    }
  }
`;
